/**
 * Contact logistics video (.js-contact-video).
 *
 * Two triggers driving one <video> that ships with preload="none" (large file):
 *  - .contact-video__play  → overlay button, starts inline playback + controls.
 *  - .contact-video__cta   → story link: play + fullscreen when stopped, pause
 *                            when already playing (toggle).
 * Both stay in sync with the real media state via the video's play/pause events,
 * so the CTA icon flips play ⇄ pause no matter which control was used
 * (.is-playing, see _contact.scss). Progressive enhancement: without JS the
 * poster stays and the CTA is a plain anchor to the player.
 */
(function () {
	'use strict';

	var figure = document.querySelector('.js-contact-video');
	if (!figure) {
		return;
	}

	var video = figure.querySelector('.contact-video__media');
	if (!video) {
		return;
	}

	var overlayBtn = figure.querySelector('.js-contact-video-play');
	var cta = document.querySelector('.js-contact-video-cta');

	function tryPlay() {
		video.controls = true;
		var promise = video.play();
		if (promise && typeof promise.catch === 'function') {
			promise.catch(function () {});
		}
	}

	function goFullscreen() {
		// iOS Safari only fullscreens the <video> element itself (webkitEnterFullscreen).
		var request =
			video.requestFullscreen ||
			video.webkitRequestFullscreen ||
			video.webkitEnterFullscreen ||
			video.msRequestFullscreen;

		if (request) {
			try {
				request.call(video);
			} catch (err) {}
		}
	}

	// Overlay button: inline playback (no fullscreen).
	if (overlayBtn) {
		overlayBtn.addEventListener('click', function () {
			tryPlay();
		});
	}

	// Story CTA: play + fullscreen from a stopped state, pause while playing.
	if (cta) {
		cta.addEventListener('click', function (event) {
			event.preventDefault();
			if (video.paused) {
				tryPlay();
				goFullscreen();
			} else {
				video.pause();
			}
		});
	}

	// Keep the UI synced with the actual media state (either trigger, or the
	// native controls, can change it).
	video.addEventListener('play', function () {
		figure.classList.add('is-playing');
		if (cta) {
			cta.classList.add('is-playing');
			cta.setAttribute('aria-label', cta.getAttribute('data-label-pause') || '');
		}
	});

	video.addEventListener('pause', function () {
		if (cta) {
			cta.classList.remove('is-playing');
			cta.setAttribute('aria-label', cta.getAttribute('data-label-play') || '');
		}
	});
})();
